import React, { useState } from "react";
import { Button, Card, Grid, Typography } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import DescriptionTab from "./descriptionTab";
import GradesTab from "./gradesTab";
import QAndATab from "./qAndATab";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import Counter from "../../../counter";
import NotesTab from "./notesTab";

const ActivityExtras = (props) => {
    const { trainingData, activityData } = props;

    const [selectedSection, setSelectedSection] = useState(0);
    const color = useSelector(getAppColor);

    return (
        <Card
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                borderRadius: 15,
                padding: 15,
                height: "100%",
                overflow: "auto",
                color: "var(--mainText)",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 10,
                }}
            >
                <Grid container direction="row" item xs={12}>
                    {[
                        {
                            key: 0,
                            label: getLocalizedString("description"),
                        },
                        {
                            key: 1,
                            label: getLocalizedString("grades"),
                        },
                        {
                            key: 2,
                            label: getLocalizedString("questions"),
                        },
                        {
                            key: 3,
                            label: getLocalizedString("notesAlt"),
                        },
                    ].map((section) => {
                        if (section.key === 1 && ["M", "L", "S"].includes(activityData.type)) return null;
                        if (
                            section.key === 1 &&
                            ["E", "P"].includes(activityData.type) &&
                            trainingData.isParticipant &&
                            !activityData?.grades?.length
                        )
                            return null;
                        if (section.key === 3 && !trainingData.isParticipant) return null;

                        const counterValue = (() => {
                            if (section.key === 1)
                                return activityData.resolutions?.filter((resolution) => !resolution.score)?.length || 0;
                            if (section.key === 2)
                                return activityData.questions?.filter((question) => !question.isClosed)?.length || 0;
                            if (section.key === 3) return Boolean(activityData.notes) ? 1 : 0;
                            return 0;
                        })();

                        const counterLabel = (() => {
                            if (section.key === 1) return getLocalizedString("pendingGrades");
                            if (section.key === 2) return getLocalizedString("openQuestions");
                            return "";
                        })();

                        return (
                            <Grid key={section.key} container item xs={12} sm={6} md={3} justify="center">
                                <Button
                                    onClick={() => setSelectedSection(section.key)}
                                    variant="contained"
                                    className="whiteText"
                                    style={{
                                        textTransform: "none",
                                        height: 36,
                                        width: "100%",
                                        margin: 5,
                                        background:
                                            section.key === selectedSection ? color : "var(--tertiaryBackgroundColor)",
                                        border:
                                            section.key === selectedSection
                                                ? `1px solid ${color}`
                                                : "1px solid var(--borderColor)",
                                        borderRadius: 18,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        position: "relative",
                                    }}
                                >
                                    <Typography align="center" style={{ fontSize: 14 }}>
                                        {section.label}
                                    </Typography>
                                    {Boolean(counterValue) && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                right: 5,
                                                top: 5,
                                            }}
                                        >
                                            <Counter value={counterValue} label={counterLabel} noColor />
                                        </div>
                                    )}
                                </Button>
                            </Grid>
                        );
                    })}
                </Grid>
            </div>
            {selectedSection === 0 && <DescriptionTab trainingData={trainingData} activityData={activityData} />}
            {selectedSection === 1 && <GradesTab trainingData={trainingData} activityData={activityData} />}
            {selectedSection === 2 && <QAndATab trainingData={trainingData} activityData={activityData} />}
            {selectedSection === 3 && <NotesTab trainingData={trainingData} activityData={activityData} />}
        </Card>
    );
};

export default ActivityExtras;
